module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAU5JREFUeNpi/P//PwOtARMDHQBdLGEhRtH06dN1gVQYEBshCR8H4i2ZmZkXCOlnJBQnQAvcgFQ+lPsSiN8BsTgQC0HF1gItmke2JUALZIDUTCD+A8RVQMOuIslZAKlaKHcKUG47uXGSCaVzkS0AS2RmngBSBVBuDtBSIZItAWpiA1IGQHwDaOAjrC7IzLwNpHZAua7kRLwklD5PwLeLgBgUrA/IsYQHSn/AG56ZmR+BVDm5+eQLlP5OaT7BmrqA8eEIpEBJVw+IPwHxQ3xmAPF/aNK+DvTZZmKDC5QvWKG+4QJiXSIdbQ/ERFsCEgeFdTIQ/4C6Fhf4D1XfB8RKpEQ8yNCPQK9/RzIIH/gNDOJnuCxhorRcQwIcw7+ox2fJPxLN+kuOJawkWsJKTuSKA1NMKwlJ2IhUS/YAsQ20FCYWgOqcS2TVjKOtFWQAEGAAVjBf9ENnmGgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/suo.png
// module id = 986
// module chunks = 1